
class exports.Zone extends KoModel

    constructor: (parent, data = {}) ->


        super()

        @ignore [
            'selected', 'acres', 'name', 'rawAcres'
        ]
        @parent = parent
        # we're ignoring ID for now.
        #@id     = data.id ? null
        @name   = data.name ? "Zone"

        # The 'value' for this zone. for example,
        # on previous crop zones, this might be "Corn"
        # or "Soybeans"
        @value      = ko.observable data.value ? null


        if data.geometry? and not (data.geometry instanceof L.FeatureGroup)
            geom = new L.FeatureGroup()
            gj = new L.GeoJSON(data.geometry)

            L.GeoUtil.unnestAdd geom, gj
        else
            geom = data.geometry ? new L.FeatureGroup()

        @geometry   = geom
        @rawAcres   = data.rawAcres ? 0
        @acres      = data.acres ? 0.00

        @selected = ko.computed () =>
            if not @parent?.selectedFeature?
                return false

            if @geometry._cloneProperties?.id is @parent.selectedFeature()
                return true

            return false


        @transform (v, key) =>
            if key is "geometry"
                wkt = new Wkt.Wkt()
                r = wkt.fromObject(v).write()
                return r
            else
                return v


        @transform (v, key) =>
            if key is "value"
                if v is true
                    return "true"
                else if v is false
                    return "false"
                else if not v?
                    return ""
                else
                    return v
            else
                return v


    getColor: () =>
        return @geometry._cloneProperties?.colorSet?.fillColor
